import React from "react";

export default function NavBar() {
  return (
    <>
      <div style={{ backgroundColor: "white" }}>
        <h1>Goi</h1>
      </div>
    </>
  );
}
